import { ApplicationConfig, inject, provideEnvironmentInitializer } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideServiceWorker } from '@angular/service-worker';
import { environment } from '../environments/environment';
import { NaturalStoppingPointService } from './core/engagement/natural-stopping-point.service';
import { AdultProgressSummaryService } from './core/learning/adult-progress-summary.service';
import { routes } from './app.routes';

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes),
    provideServiceWorker('ngsw-worker.js', {
      enabled: environment.pwa,
      registrationStrategy: 'registerImmediately',
      updateViaCache: 'none'
    }),
    provideEnvironmentInitializer(() => inject(NaturalStoppingPointService).start()),
    provideEnvironmentInitializer(() => inject(AdultProgressSummaryService).start())
  ]
};
